import React from "react";

const BannerTitles = ({ title }) => {
	return (
		<div className="site-container page-heading">
			<h1 className="page-title">{title}</h1>
			<div className="accent-line" />
		</div>
	);
};

export default BannerTitles;
